'use client'

import { Button } from '@components/button'
import { BodyText, HeadlineText } from 'design-configuration/components'
import { OnboardingStepHeader } from './onboarding-step-header'
import { onboardingStore } from './store'

function MagentaGradientStar({ className }: { className?: string }) {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M60.2949 24.6086C60.0449 23.8399 59.5729 23.1624 58.9385 22.6615C58.3041 22.1605 57.5356 21.8586 56.7299 21.7936L41.9799 20.6036L36.2849 6.8311C35.9769 6.08064 35.4527 5.43872 34.779 4.98694C34.1052 4.53517 33.3124 4.29395 32.5012 4.29395C31.69 4.29395 30.8971 4.53517 30.2234 4.98694C29.5496 5.43872 29.0254 6.08064 28.7174 6.8311L23.0274 20.6011L8.26992 21.7936C7.46287 21.8619 6.6939 22.1668 6.05936 22.6701C5.42482 23.1735 4.95294 23.8529 4.70283 24.6232C4.45271 25.3936 4.4355 26.2206 4.65334 27.0007C4.87118 27.7808 5.31438 28.4793 5.92742 29.0086L17.1774 38.7161L13.7499 53.2311C13.5582 54.0197 13.6052 54.8474 13.8848 55.6093C14.1644 56.3711 14.664 57.0327 15.3203 57.51C15.9766 57.9874 16.7599 58.259 17.5709 58.2903C18.3818 58.3217 19.1837 58.1114 19.8749 57.6861L32.4999 49.9161L45.1324 57.6861C45.8239 58.1063 46.6242 58.3126 47.4326 58.2789C48.241 58.2452 49.0214 57.973 49.6754 57.4967C50.3295 57.0204 50.828 56.3612 51.1082 55.6022C51.3883 54.8431 51.4377 54.0181 51.2499 53.2311L47.8099 38.7136L59.0599 29.0061C59.6779 28.4777 60.1252 27.7777 60.345 26.9948C60.5649 26.212 60.5475 25.3815 60.2949 24.6086ZM56.4599 25.9761L44.2849 36.4761C44.0073 36.7154 43.8007 37.0264 43.6879 37.3752C43.575 37.7239 43.5601 38.097 43.6449 38.4536L47.3649 54.1536C47.3745 54.1752 47.3755 54.1998 47.3676 54.2221C47.3597 54.2444 47.3435 54.2628 47.3224 54.2736C47.2774 54.3086 47.2649 54.3011 47.2274 54.2736L33.5474 45.8611C33.2324 45.6674 32.8698 45.5648 32.4999 45.5648C32.1301 45.5648 31.7675 45.6674 31.4524 45.8611L17.7724 54.2786C17.7349 54.3011 17.7249 54.3086 17.6774 54.2786C17.6563 54.2678 17.6402 54.2494 17.6322 54.2271C17.6243 54.2048 17.6253 54.1802 17.6349 54.1586L21.3549 38.4586C21.4397 38.102 21.4248 37.7289 21.312 37.3802C21.1991 37.0314 20.9926 36.7204 20.7149 36.4811L8.53992 25.9811C8.50992 25.9561 8.48242 25.9336 8.50742 25.8561C8.53242 25.7786 8.55242 25.7886 8.58992 25.7836L24.5699 24.4936C24.9364 24.4622 25.2872 24.3302 25.5836 24.1124C25.88 23.8945 26.1106 23.5991 26.2499 23.2586L32.4049 8.3561C32.4249 8.3136 32.4324 8.2936 32.4924 8.2936C32.5524 8.2936 32.5599 8.3136 32.5799 8.3561L38.7499 23.2586C38.8906 23.5992 39.1226 23.8943 39.4204 24.1113C39.7182 24.3284 40.0701 24.4589 40.4374 24.4886L56.4174 25.7786C56.4549 25.7786 56.4774 25.7786 56.4999 25.8511C56.5224 25.9236 56.4999 25.9511 56.4599 25.9761Z"
        fill="url(#paint0_linear_161_44629)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_161_44629"
          x1="4.50171"
          y1="31.2937"
          x2="60.498"
          y2="31.2937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD0045" />
          <stop offset="0.5" stopColor="#FD02D4" />
          <stop offset="1" stopColor="#A000FD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

function BlueGradientStar({ className }: { className?: string }) {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M54.5 16.2939H14.5C13.9696 16.2939 13.4609 16.0832 13.0858 15.7082C12.7107 15.3331 12.5 14.8244 12.5 14.2939C12.5 13.7635 12.7107 13.2548 13.0858 12.8797C13.4609 12.5047 13.9696 12.2939 14.5 12.2939H48.5C49.0304 12.2939 49.5391 12.0832 49.9142 11.7082C50.2893 11.3331 50.5 10.8244 50.5 10.2939C50.5 9.76351 50.2893 9.2548 49.9142 8.87973C49.5391 8.50466 49.0304 8.29395 48.5 8.29395H14.5C12.9087 8.29395 11.3826 8.92609 10.2574 10.0513C9.13214 11.1765 8.5 12.7026 8.5 14.2939V46.2939C8.5 47.8852 9.13214 49.4114 10.2574 50.5366C11.3826 51.6618 12.9087 52.2939 14.5 52.2939H54.5C55.5609 52.2939 56.5783 51.8725 57.3284 51.1224C58.0786 50.3722 58.5 49.3548 58.5 48.2939V20.2939C58.5 19.2331 58.0786 18.2157 57.3284 17.4655C56.5783 16.7154 55.5609 16.2939 54.5 16.2939ZM54.5 48.2939H14.5C13.9696 48.2939 13.4609 48.0832 13.0858 47.7082C12.7107 47.3331 12.5 46.8244 12.5 46.2939V19.9514C13.1422 20.1791 13.8187 20.2949 14.5 20.2939H54.5V48.2939ZM42.5 33.2939C42.5 32.7006 42.6759 32.1206 43.0056 31.6272C43.3352 31.1339 43.8038 30.7494 44.352 30.5223C44.9001 30.2952 45.5033 30.2358 46.0853 30.3516C46.6672 30.4673 47.2018 30.7531 47.6213 31.1726C48.0409 31.5922 48.3266 32.1267 48.4424 32.7087C48.5581 33.2906 48.4987 33.8938 48.2716 34.442C48.0446 34.9902 47.6601 35.4587 47.1667 35.7884C46.6734 36.118 46.0933 36.2939 45.5 36.2939C44.7043 36.2939 43.9413 35.9779 43.3787 35.4153C42.8161 34.8527 42.5 34.0896 42.5 33.2939Z"
        fill="url(#paint0_linear_161_44626)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_161_44626"
          x1="8.5"
          y1="30.2939"
          x2="58.5"
          y2="30.2939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9401FD" />
          <stop offset="0.52" stopColor="#1417FC" />
          <stop offset="1" stopColor="#0BA6FD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ChoosePathStep(): React.ReactNode {
  return (
    <div className="flex min-h-full flex-col">
      <OnboardingStepHeader
        className="mb-md"
        title="Let's set up your Art Blocks experience"
        subtitle="We've created a secure digital wallet linked to your account for your art collection. You can start collecting right away, or connect an existing wallet if you have one."
      />
      <div className="gap-xs px-md mb-sm flex flex-1 flex-col sm:flex-row">
        <div className="p-md relative flex flex-1 flex-col items-center justify-center">
          <div className="rounded-xs absolute inset-0 -z-[1]" style={{ background: 'var(--magenta-gradient)' }} />
          <div className="bg-surface absolute inset-[1px] -z-[1] rounded-[1px]" />
          <div className="h-16 w-16">
            <MagentaGradientStar className="h-full w-full" />
          </div>
          <HeadlineText className="mb-sm text-center font-light">Set up my profile</HeadlineText>
          <div className="mb-sm h-[1px] w-full" style={{ background: 'var(--magenta-gradient)' }} />
          <BodyText className="mb-md text-center">
            Use the account we&apos;ve set up for you and start exploring amazing art on Art Blocks.
          </BodyText>
          <Button
            colorTheme="primary"
            branded
            onClick={() => onboardingStore.trigger.choosePathStepCompleted({ nextStep: 'PROFILE_SETUP' })}
          >
            Setup profile
          </Button>
        </div>
        <div className="border-outline-variant rounded-xs p-md relative flex flex-1 flex-col items-center justify-center border">
          <div className="h-16 w-16">
            <BlueGradientStar className="h-full w-full" />
          </div>
          <HeadlineText className="mb-sm text-center font-light">I have an existing wallet</HeadlineText>
          <div className="mb-sm h-[1px] w-full" style={{ background: 'var(--blue-purp-gradient)' }} />
          <BodyText className="mb-md text-center">
            Connect a wallet you already use to see any Art Blocks pieces you might already own.
          </BodyText>
          <Button
            colorTheme="primary"
            branded
            onClick={() => onboardingStore.trigger.choosePathStepCompleted({ nextStep: 'LINK_ACCOUNTS' })}
          >
            Connect wallet
          </Button>
        </div>
      </div>
      <div className="px-md pb-md">
        <div className="bg-surface-container p-sm flex justify-center">
          <BodyText className="text-center">
            Don&apos;t worry - you can always connect additional wallets later from your profile.
          </BodyText>
        </div>
      </div>
    </div>
  )
}
